import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';

@Component({
  selector: 'app-statement-component',
  templateUrl: './statement-component.component.html',
  styleUrls: ['./statement-component.component.scss']
})
export class StatementComponentComponent implements OnInit, OnChanges {

  @Input() statementList;
  @Output() emitScroll: EventEmitter<any> = new EventEmitter();
  @Input() pageLoading = false;
  page = 0;
  pageSize = 20;
  constructor() { }

  ngOnInit(): void {
    this.statementList.forEach(element => {
      element.absAmount = Math.abs(element.amount);
    });
  }
  ngOnChanges() { }
  onScroll() {
    this.emitScroll.emit('');
  }
}
